import React, { useState } from "react";
import { Select } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { postBudgetReportData } from "../../redux/slices/loginSlice";
import "./BudgetDetailReports.css";
import swal from "sweetalert";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import BUDGET_API from "../../apis/budget.api";
const { Option } = Select;

export const BudgetDetailReports = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const tags = ["Spreadsheet", "Chart"];
  let currentYear = new Date().getFullYear();
  let years = [];
  for (let i = 2018; i <= currentYear; i++) {
    years.push(i);
  }
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [selectedYears, setSelectedYears] = useState([]);
  const [selectedMonths, setSelectedMonths] = useState([]);

  const handleYearClick = (year) => {
    if (selectedYears.includes(year)) {
      setSelectedYears(selectedYears.filter((y) => y !== year));
    } else {
      setSelectedYears([...selectedYears, year]);
    }
  };

  const handleMonthClick = (month) => {
    if (selectedMonths.includes(month)) {
      setSelectedMonths(selectedMonths.filter((m) => m !== month));
    } else {
      setSelectedMonths([...selectedMonths, month]);
    }
  };

  const hanldeGenerateReport = async () => {
    if (selectedMonths.length === 0 && selectedYears.length === 0) {
      swal("Error", "Please Select Year or Month to Generate Report!", "error");
    }
    const monthValues =
      selectedMonths &&
      selectedMonths.map((month) => {
        const index = months.indexOf(month) + 1;
        return index.toString().padStart(2, "0");
      });
    console.log("months", selectedMonths, monthValues, selectedYears);
    let payload = {
      months: monthValues && monthValues,
      years: selectedYears && selectedYears,
    };
    console.log("payload", payload, selectedMonths);
    // history.push("/reports/budgetDetails/allReports");
    try {
      setLoading(true);
   
      const response = await BUDGET_API.createTransactionsReport(payload);
      console.log("response", response);
      if (
        response &&
        response.status === 200 &&
        response.data
      ) {
        dispatch(postBudgetReportData(response.data));
        history.push("/reports/budgetDetails/allReports");
      }
      if (response && response.status === 400) {
        swal("Error", response.message, "error");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response.data) {
        swal("Error", error.response.data.message, "error");
      }
      console.error("Error fetching user data:", error);
    }
  };

  return (
    <div className="BudgetReportMain">
      <div className="budgetSection">
        <div className="addTitle">Budget Details </div>
        {/*<div className="budgetDetails" style={{ gap: "1rem" }}>
          <button
            className="exportButton"
            onClick={() => {
              // setCategoryModal(true);
            }}
          >
            {" "}
            Export
          </button>
          <div className="filterIcons">
            <Select
              showSearch
              style={{ width: 200, outline: "none", border: "none" }}
              placeholder="Select Filter"
              onChange={(value, id) => {
                console.log("value", value);
                // setFilterData(value);
                // handleApplyFilter(value);
              }}
            >
              {tags &&
                tags.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
            </Select>
          </div>
              </div> */}
      </div>
      <div className="mainTitle">
        Select Year(s) and Month(s), then Generate Report
      </div>
      <div className="yearsCardsSection">
        {years &&
          years.map((year) => (
            <div
              key={year}
              className={`yearsCards ${
                selectedYears.includes(year) ? "yearsCardsActive" : "yearsCards"
              }`}
              // className="yearsCards"
              onClick={() => handleYearClick(year)}
            >
              {year}
            </div>
          ))}
      </div>
      <div className="monthCardsSection">
        {months &&
          months.map((month) => (
            <div
              key={month}
              className={`monthCards ${
                selectedMonths.includes(month) ? "monthCardsActive" : ""
              }`}
              onClick={() => handleMonthClick(month)}
            >
              {month}
            </div>
          ))}
      </div>
      <div className="buttonSection">
        <button
          className={
            selectedMonths.length === 0 && selectedYears.length === 0
              ? "exportButton disableButton"
              : "exportButton"
          }
          disabled={selectedMonths.length === 0 && selectedYears.length === 0}
          onClick={() => {
            hanldeGenerateReport();
          }}
        >
          {" "}
          Generate Reports
        </button>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
